/**
 * Sanitize and validate email address
 */
export const sanitizeEmail = (email: string): string => {
  return email.toLowerCase().trim();
};

/**
 * Validate email format
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validate profile data
 */
export const validateProfile = (
  email: string,
): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Email validation
  if (!email || email.trim().length === 0) {
    errors.push('Email is required');
  } else if (!isValidEmail(sanitizeEmail(email))) {
    errors.push('Please enter a valid email address');
  }
  return {
    isValid: errors.length === 0,
    errors,
  };
};
